<template>
    <div class="app-inner" @keyup.enter="login()">
        <!--<div class="c-header">-->
            <!--<div class="logo">-->
                <!--<img class="logo-img" src="@/assets/logo.png">-->
            <!--</div>-->
        <!--</div>-->
        <div class="login-context">
            <div class="login-interface">
                <div class="logo">
                    <img src="@/assets/logoS.png" alt="LOGO"/>
                    <div class="text-login">
                        <div>逍逍 · 订单机器人</div>
                    </div>
                </div>
                <div class="entry">
                    <el-input placeholder="账号" auto-complete="off" class="input" v-model="username" ref="r_username" autofocus="true">

                      <el-select v-model="select" slot="prepend" placeholder="请选择" class="input_select">
                        <el-option :label="item.area_name" :value="item.ncode" v-for="(item,index) in AreaList" :key="'area'+index">
                          <div style="display: flex;justify-content: space-between;align-items: center">
                            <span>{{item.area_name}}</span>
                            <span>+{{item.ncode}}</span>
                          </div>
                        </el-option>
                      </el-select>

                    </el-input>
                    <el-input placeholder="密码" auto-complete="off" type="password" class="input" v-model="password" ref="r_password" autofocus="true"></el-input>
                    <el-checkbox class="checkbox"  v-model="autologin">15天内自动登录</el-checkbox>
                    <el-button type="primary" class="into" @click="login()">{{isLogining?'登录中...':'登录'}}</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import appTool from '@/common/appTool'
export default {
    data: function () {
        return {
            username: localStorage.getItem('sysale-robot-username')||'',
            password:'',
            autologin:false,
            isLogining:false,
            AreaList:[],
            select:86
        }
    },
    created(){
          this.getLandingAreas();
    },
    methods:{

      //获取登陆区域列表
      getLandingAreas:function () {
        let _this=this;
        _this.xFetch.post(_this.xApi("/xx_admin/user.Login/list_login_area/cn"), {}).then(function (res) {
          if(res.data.ret_status=='ok'){
            res.data.list_area.splice(1,0,{area_name:'中国澳门',ncode:853});
            res.data.list_area.splice(1,0,{area_name:'中国香港',ncode:852});
            _this.AreaList=res.data.list_area;
          }
        });
      },
        login:function(){
            let self = this;
            // check
            if(!self.username){
                appTool.eui.msg_error('请输入用户名')
                self.$refs.r_username.$refs.input.focus()
                return
            }
            if(!self.password){
                appTool.eui.msg_error('请输入密码')
                self.$refs.r_password.$refs.input.focus()
                return
            }

            // login
            if(self.isLogining)
                return;

            self.isLogining = true
            self.xFetch.post(self.xApi('/robot/admin/user/login'), {
                "empAcct": self.username,
                "empPswd": self.password,
                "ncode": self.select,
                "sDay": self.autologin==true?15:null,
            }).then(function(res){
//                console.log(res)
//                return
                self.isLogining = false
                if (res.data.code != '00') {
                    self.xEui.msg_error(res.data.text)
                    return
                }

                // 登录成功
                var d = res.data.data;
                let user = {
                    id: d.empNo,
                    account: d.empAcct,
                    name: d.empName,
                    loginTime: new Date().getTime(),
                    expire: self.autologin ? 15 : 3,
                    avatar:'static/img/avatar.png', // 服务端未返回头像
                    data: d
                }
                self.xAppTool.setUser(user);
                localStorage.setItem('sysale-robot-username',self.username); // 缓存用户名
                location.reload();
            });
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
/*---*/
.c-header {height: 60px;background: #409EFF;position: absolute}
.c-header .logo{  }
.c-header .logo-img{ float: left;height: 36px;margin: 12px 0px 0px 28px  }
/*---*/
.login-context{
  height: 100%;
  background-color: #409EFF;
  overflow: auto;
  display: flex;
  align-items: center;
    label.el-checkbox{
        line-height: normal;
    }
}
.login-interface{
  width: 450px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 10px rgba(26,26,26,.1);
  box-sizing: border-box;
  .logo{
    text-align: center;
    padding-top: 30px;
    img{
      /*width: 150px;*/
      /*height: 150px;*/
    }
    .text-login{
      padding-top: 10px;
      font-size: 20px;
      color: #409EFF;
    }
  }
  .entry{
    padding: 20px 30px;
    .input{
      margin: 10px 0;
      .pad-lr{
        padding: 5px;
      }
      .diy-icon{
        font-size: 24px;
      }
    }
    .input_select{
      width: 120px;
    }
    .checkbox{
      margin-top: 10px;
    }
    .into{
      margin: 20px 0;
      width: 100%;
    }
    .forget{
      text-align: center;
    }
    .margin-none{ margin: 0 }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue